import { render, staticRenderFns } from "./assetBrandList.vue?vue&type=template&id=0cc9c0f8"
import script from "./assetBrandList.vue?vue&type=script&lang=js"
export * from "./assetBrandList.vue?vue&type=script&lang=js"
import style0 from "./assetBrandList.vue?vue&type=style&index=0&id=0cc9c0f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports